import React from 'react';
import VideoLoop from '../VideoLoop'
import styled from 'styled-components'
const VidThirds = styled.div`
    .vid-one {
        grid-area: vid-1;
    }
   
    .vid-23-text-grid {
        display: grid;
        column-gap: 1rem;
        grid-template-columns: [vid-1] 7fr [spacer] 1fr [text] 4fr;
        &.reverse {
            direction: rtl;
        }
    }
    .text-one-third{
        grid-area: text;
        p {
            font-size: 1.666rem;
            &:first-child {
                margin-top: 0;
            }
        }
    }
    @media all and (max-width: 767px) {
        .vid-23-text-grid {
            display: block;
        }
        .text-one-third {
            padding-top: 1.25rem;
            p {
                padding-left: 2rem;
                padding-right: 2rem;
                font-size: 1.333rem;
                text-align: center;
            }
        }
    }
`
const VideoLoop23Text = ({src, description, text}) => {
  return (
      <VidThirds className="row-component">
          <div className="vid-23-text-grid">
                <div className="vid-one">
                    <VideoLoop src={src} description={description} />
                </div>
                <div className="text-one-third">
                     <div dangerouslySetInnerHTML={{__html: text}} />
                </div>
            </div>
      </VidThirds>
  );
};

export default VideoLoop23Text;
